import type { AccountData as Account } from '~publish/contexts/AccountContext'

export function isRevenueCatBillingGateway(account: Account): boolean {
  let billingGateway: string | undefined
  const currentOrganization = account?.currentOrganization
  if (currentOrganization?.billing?.__typename === 'OBBilling') {
    billingGateway = currentOrganization?.billing?.gateway?.gatewayType
  }
  return billingGateway === 'revenuecat'
}

export function isPaymentMethodBank(account: Account): boolean {
  let paymentMethod: string | undefined | null
  const currentOrganization = account?.currentOrganization
  if (currentOrganization?.billing?.__typename === 'OBBilling') {
    paymentMethod = currentOrganization?.billing?.paymentDetails?.paymentMethod
  }
  return paymentMethod === 'bank'
}

export function isTeamPlan(account: Account): boolean {
  const currentOrganization = account?.currentOrganization
  return (
    currentOrganization?.billing?.__typename === 'OBBilling' &&
    currentOrganization?.billing?.subscription?.plan?.id === 'team'
  )
}

export function isFreePlan(account: Account): boolean {
  const currentOrganization = account?.currentOrganization
  return (
    currentOrganization?.billing?.__typename === 'OBBilling' &&
    currentOrganization?.billing?.subscription?.plan?.id === 'free'
  )
}

export function isEssentialsPlan(account: Account): boolean {
  const currentOrganization = account?.currentOrganization
  return (
    currentOrganization?.billing?.__typename === 'OBBilling' &&
    currentOrganization?.billing?.subscription?.plan?.id === 'essentials'
  )
}
